import { X } from 'lucide-react'
import { useAppStore } from '@core/store'
import type { ToastType } from '@core/store/toastSlice'

// Host único dos toasts de confirmação. Montado no PopupsHost (presente
// em ambos os shells, local e cloud), mostra a fila do toastSlice como
// barras fixas no canto inferior direito. aria-live="polite" e
// role="status" para leitores de ecrã; cada toast fecha-se sozinho pelo
// timeout ou com o ✕. Estilo alinhado com os painéis flutuantes
// (var(--color-surface)/border/text), com uma barra lateral de cor por
// tipo (verde: sucesso, vermelho: erro, acento: informação).

const TYPE_BORDER: Record<ToastType, string> = {
  success: 'border-l-emerald-400',
  error: 'border-l-red-400',
  info: 'border-l-[var(--color-accent)]',
}

export default function ToastHost() {
  const toasts = useAppStore((s) => s.toasts)
  const dismiss = useAppStore((s) => s.dismissToast)

  if (toasts.length === 0) return null

  return (
    <div
      className="pointer-events-none fixed right-3 bottom-3 z-[1100] flex max-w-[min(92vw,360px)] flex-col gap-1.5"
      role="status"
      aria-live="polite"
      aria-atomic="false"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto flex items-start gap-2 rounded border border-l-2 border-[var(--color-border)] bg-[var(--color-surface)] px-2.5 py-1.5 text-[11px] leading-snug text-[var(--color-text)] shadow-2xl ${TYPE_BORDER[t.type]}`}
        >
          <span className="min-w-0 flex-1">{t.message}</span>
          {t.acao && (
            <button
              type="button"
              onClick={() => {
                dismiss(t.id)
                t.acao?.executar()
              }}
              className="shrink-0 rounded border border-[var(--color-accent-border)] px-1.5 text-[11px] font-medium text-[var(--color-accent)] hover:bg-[var(--color-accent-bg)]"
            >
              {t.acao.rotulo}
            </button>
          )}
          <button
            type="button"
            onClick={() => dismiss(t.id)}
            title="Fechar aviso"
            aria-label="Fechar aviso"
            className="-mr-0.5 shrink-0 rounded p-0.5 text-[var(--color-text-dim)] hover:text-[var(--color-text)]"
          >
            <X size={12} />
          </button>
        </div>
      ))}
    </div>
  )
}
